import { useEffect } from "react";

import { usePatientQuery } from "@/app/hooks";
import { usePortalUserStore } from "@/app/stores";
import { useCustomerIoContext } from "@/features/analytics/providers";
import { triggerCustomerIoShopPageViewed } from "@/features/analytics/triggers";
import { useSettingsStore } from "@/shared/stores";

export const useMarkShopVisited = () => {
  const { analytics } = useCustomerIoContext();

  const language = useSettingsStore((state) => state.language);

  const user = usePortalUserStore((state) => state.portalUser);
  const { data: patient } = usePatientQuery();

  useEffect(() => {
    if (user && patient) {
      triggerCustomerIoShopPageViewed({
        analytics,
        userInfo: {
          email: user.email,
          firstName: patient.firstName,
          lastName: patient.lastName,
          phone: patient.phoneNumber,
          dateOfBirth: patient.dateOfBirth,
          gender: user.gender,
          state: patient.location?.state,
        },
        language,
      });
    }
  }, [patient]); // eslint-disable-line react-hooks/exhaustive-deps
};
